const purchasesMenu = [
  {
    System: 'PUR',
    menu: [
      // { is_header: true, title: 'Purchases', isActive: true },
      { is_header: true, title: '', isActive: true },

      {
        path: '/PUR/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'Operations', isActive: true },

      {
        path: '/PUR/PurchaseRequests',
        icon: 'fas fa-shopping-cart',
        title: 'PurchaseRequests',
        permission: 'PURViewPurchaseRequestsList',
        isActive: true
      },
      {
        path: '/PUR/Quotation',
        icon: 'fas fa-tags',
        title: 'Quotations',
        permission: 'PURViewQuotationsList',
        isActive: true
      },
      {
        path: '/PUR/PurchaseOrder',
        icon: 'fas fa-file-invoice-dollar',
        title: 'PurchaseOrders',
        permission: 'PURViewPurchaseOrderList',
        isActive: true
      },
      {
        path: '/PUR/ReturnsPurchase-Order',
        // path: '/PUR/PurchaseReturn',
        icon: 'fas fa-undo-alt',
        title: 'مردود مشتريات امر شراء',
        permission: '',
        isActive: true
      },
      {
        path: '/PUR/ReturnsPurchase',
        icon: 'fas fa-undo-alt',
        title: 'PurchaseReturns',
        permission: '',
        isActive: true
      },

      {
        path: '/PUR/ReceiveNoneInventoryItem',
        icon: 'fas fa-box-open',
        // title: 'ReceiveNoneInventoryItems',
        // title: 'معالجة أوامر الشراء غير المخزنية',
        title: 'معالجة العمليات غير المخزنية',
        permission: 'PURViewPurchaseOrderNoneInventoryList',
        isActive: true
      },
      {
        path: '/PUR/AccountingPeriod',
        title: 'AccountingPeriod',
        icon: 'fas fa-calendar-alt',
        permission: 'PURViewAccountingPeriodsList',
        isActive: true
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/PUR/SUPPLIERS',
        icon: 'fas fa-users',
        title: 'Suppliers',
        permission: 'PURViewSuppliersList',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },

      {
        path: '/PUR/PurchaseReports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        permission: '',
        isActive: true
      },
      {
        path: '/PUR/PurchaseDashboards',
        icon: 'fas fa-tachometer-alt',
        title: 'Dashboard',
        permission: '',
        isActive: true
      }
    ]
  }
];

export default purchasesMenu;
